import { render, staticRenderFns } from "./VoucherApprovals.vue?vue&type=template&id=2fb82cef&scoped=true&"
import script from "./VoucherApprovals.vue?vue&type=script&lang=js&"
export * from "./VoucherApprovals.vue?vue&type=script&lang=js&"
import style0 from "./VoucherApprovals.vue?vue&type=style&index=0&id=2fb82cef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb82cef",
  null
  
)

export default component.exports